



$(document).ready(function($) {

  $titles = $('#js-typed-titles');
  if ( $titles.length > 0) {
    var typed = new Typed('#js-typed-target', {
      stringsElement: '#js-typed-titles',
      typeSpeed: 100,
      startDelay: 0,
      backSpeed: 50,
      backDelay: 2000,
      loop: true
    });
  }
});
